import { createFileRoute } from '@tanstack/react-router';
import { zodValidator } from '@tanstack/zod-adapter';
import { bankUploadEndCallbackSchema } from 'pages/upload-info-pages/bank/bank.types';
import { UploadBankInfo } from 'pages/upload-info-pages';
import { pooDocumentType } from 'services/ocr-ms/post-jumio-doc-proof-payment';
import z from 'zod';

const bankInfoSchema = z.object({
  billcodeId: z.string().or(z.number()),
  documentType: pooDocumentType.optional(),
  endCallback: bankUploadEndCallbackSchema.optional(),
});

export const Route = createFileRoute('/upload-bank-info')({
  validateSearch: zodValidator(bankInfoSchema),
  component: UploadBankInfo,
});
